import "./init";
import { StrictMode, Suspense, useEffect } from "react";

import { ApolloProvider } from "@apollo/client";
import { EmbedThemeProvider } from "@hl/base-components/lib/theme/provider";
import { loadIframely } from "@hl/communities-app/lib/services/iframely";
import { AuthProvider } from "@hl/shared-features/lib/features/auth";
import { EmbedAppBootstrap } from "@hl/shared-features/lib/features/auth/AppBootstrap";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en.json";
import { createRoot } from "react-dom/client";

import { PageViewEmbed } from "./features/pages/PageViewEmbed";
import { createEmbedApolloClient } from "./services/apolloClient";

try {
  TimeAgo.addDefaultLocale(en);
} catch (err) {
  console.warn("time ago init error", err);
  // ignore error, as site can have TimeAgo initialized already
}

type EmbedAppProps = {
  pageSlug: string;
  customerEmbedId?: string;
};
const EmbedApp: React.FC<EmbedAppProps> = ({ pageSlug }) => {
  useEffect(() => {
    loadIframely();
  }, []);
  // TODO: https://linear.app/highlight-xyz/issue/ENG-3440/analytics-for-page-embeds

  return (
    <EmbedThemeProvider>
      <Suspense fallback={""}>
        <AuthProvider>
          <EmbedAppBootstrap>
            <PageViewEmbed pageSlug={pageSlug} />
          </EmbedAppBootstrap>
        </AuthProvider>
      </Suspense>
    </EmbedThemeProvider>
  );
};

const renderPage = (
  container: Element,
  { pageSlug, customerEmbedId }: EmbedAppProps
) => {
  const root = createRoot(container);
  root.render(
    <StrictMode>
      <ApolloProvider
        client={createEmbedApolloClient(customerEmbedId ?? "beta")}
      >
        <EmbedApp pageSlug={pageSlug} />
      </ApolloProvider>
    </StrictMode>
  );
};

let stopRender = false;
document
  .querySelectorAll(`[data-widget="highlight-gated-page"]`)
  .forEach((container) => {
    const pageSlug = container.getAttribute("data-page-slug");
    const customerEmbedId = container.getAttribute("data-customer-embed-id");
    if (!stopRender && pageSlug) {
      renderPage(container, {
        pageSlug,
        customerEmbedId: customerEmbedId ?? "beta",
      });
      // multiple HL pages instances are not supported
      stopRender = true;
    }
  });
